import React from 'react';
import { MenuOutlined } from '@ant-design/icons';
import Drawer from 'antd/lib/drawer';
import Text from 'antd/lib/typography/Text';
import { AppComponentProps } from '../../../typescriptHelpers';
import { antGrey } from '../../styles/globalStyles';
import { AppNavigationContent } from '../../sidebar/AppNavigationContent';
import { useWindowDimensions } from './useWindowDimensions';
import { useIsMobile } from '../../../mediaQueriesHelpers';
import styles from '../../styles/timelineStyles';

export interface MobileSideBarHeaderProps extends AppComponentProps {
    title: string;
    children: React.ReactNode;
    topRightComponent?: React.ReactNode;
    topLeftComponent?: React.ReactNode | ((titleComponent: React.ReactNode) => React.ReactNode);
}

export const MobileSideBarHeader: React.FC<MobileSideBarHeaderProps> = ({
    title,
    children,
    topRightComponent,
    topLeftComponent,
    ...rest
}) => {
    const [isMenuExpanded, setIsMenuExpanded] = React.useState(false);

    const isMobile = useIsMobile();

    if (!isMobile) {
        return <>{children}</>;
    }

    const { width } = useWindowDimensions();

    const titleComponent = (
        <Text
            ellipsis
            style={{
                fontSize: 16,
                color: antGrey.grey7,
                textTransform: 'uppercase',
                fontWeight: 600,
                letterSpacing: '0.1em',
            }}
        >
            {title}
        </Text>
    );

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '22px 20px',
                    position: 'relative',
                    flexGrow: 1,
                    alignItems: 'center',
                    maxHeight: 70,
                    backgroundColor: antGrey.grey3,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: 0,
                        gap: 16,
                    }}
                >
                    <MenuOutlined
                        style={{ fontSize: 20, cursor: 'pointer' }}
                        onClick={() => {
                            setIsMenuExpanded(true);
                        }}
                    />

                    {typeof topLeftComponent === 'function' ?
                        topLeftComponent(titleComponent)
                    :   <>
                            {titleComponent}
                            {topLeftComponent}
                        </>
                    }
                </div>
                {topRightComponent}
                <Drawer
                    onClose={() => {
                        setIsMenuExpanded(false);
                    }}
                    open={isMenuExpanded}
                    placement="left"
                    closable={false}
                    width={width * 0.85}
                    bodyStyle={{ padding: 0 }}
                >
                    <div style={{ ...styles.timelineStyle, justifyContent: 'flex-start' }}>
                        <AppNavigationContent {...rest} />
                    </div>
                </Drawer>
            </div>
            {children}
        </>
    );
};
